import { connect, Component } from "macguffin"
import GameMode from "game/modes"
import GameModeGroup from "game/modes/GameModeGroup"
import ArrayHelper from "utils/ArrayHelper"

import BackgroundImage from "utils/BackgroundImage"

const METER_LEVELS = [
    0.145, //0 EARTH
    0.19, //1
    0.25, //2
    0.32, //3
    0.36, //4
    0.415, //5 P1
    0.46, //6
    0.52, //7
    0.59, //8
    0.635, //9
    0.69, //10 P2
    0.73, //11
    0.79, //12
    0.86, //13
    0.905, //14
    1 //15 MARS!
]

const PICK_STAGES = [0, 5, 10, 15]

const meterStyle = {
    backgroundPosition: "top right"
}

const meterLevelStyle = {
    backgroundPosition: "center"
}

@connect(state => ({
    currentGameMode: state.game.currentGameMode,
    currentPickStageIndex: state.game.currentPickStageIndex,
    currentFreespins: state.game.currentFreespins,
    meterPosition: state.game.meterPosition,
    currentPickResultData: state.game.currentPickResultData,
}), {})

export default class ProgressionMeter extends Component {

    componentWillMount() {

    }

    componentWillReceiveProps(nextProps) {
        const currentProps = this.props
    }

    render() {
        const { picks } = this.state || {}
        const { width, height, visibility, currentFreespins, meterPosition } = this.props || {}

        if (isNaN(meterPosition)) {
            return <div/>
        }

        const style = {
            width: `${width}px`,
            height: `${height}px`,
            visibility
        }

        const percentage = METER_LEVELS[meterPosition]
        const clip = height * (1 - percentage)

        //use overflow: hidden instead of clip-path as it's better supported on iOS
        const maskStyle = {
            transform: `translateY(${clip + (0.025 * height)}px)`
        }

        const colouredStyle = {
            transform: `translateY(${-clip}px)`,
            backgroundPosition: "top right"
        }

        const dotStyle = {
            left: `${width * 0.55}px`,
            top: `${width * 0.2}px`,
            width: `${width * 0.25}px`,
            height: `${width * 0.25}px`,
            transform: `translateY(${clip}px)`,
            opacity: !PICK_STAGES.includes(meterPosition) ? 1 : 0
        }
        return <div className="progressionMeterContainer" style={style}>
            <BackgroundImage className="progressionMeterGreyscale" assetName="progressionMeter" style={meterStyle}/>
            <div className="progressionMeterMask" style={maskStyle}>
                <BackgroundImage className="progressionMeterColoured" assetName="progressionMeter" style={colouredStyle}/>
            </div>
            <div className="progressionMeterDot" style={dotStyle}>
                <BackgroundImage assetName="progressionMeterDot" style={meterLevelStyle}/>
            </div>
        </div>
    }
}
